import { render, staticRenderFns } from "./courseView.vue?vue&type=template&id=7a549e51&"
import script from "./courseView.vue?vue&type=script&lang=js&"
export * from "./courseView.vue?vue&type=script&lang=js&"
import style0 from "./courseView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports